import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../config/axiosConfig";
import { PROGRAMMES_URL } from "../../settings/APISetting";
import { sortByProp } from "../../settings/themeSettings";

export const fetchProgrammes = createAsyncThunk('fetch-programme', async (page = 1) => {
    const response = await api.get(PROGRAMMES_URL);
    return response.data;
});

export const createProgram = (program, err, cb) => {
    api.post(PROGRAMMES_URL, program)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const updateProgram = (program, err, cb) => {
    api.put(`${PROGRAMMES_URL}/${program.id}`, program)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const deleteProgram = (id, err, cb) => {
    api.delete(`${PROGRAMMES_URL}/${id}`)
        .then((response) => {
            if (cb) cb(response);
        })
        .catch((error) => {
            if (err) err(error);
        });
}
const programmeSlice = createSlice({

    name: 'programmes',
    initialState: { programmes: [], programmesFetchStatus: '' },

    reducers: {
        addProgram: (state, action) => {
            state.programmes = [...state.programmes, action.payload].sort((a,b) => sortByProp(a,b,'libelle'));
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchProgrammes.fulfilled, (state, action) => {
            if (Array.isArray(action.payload)) {
                state.programmes = [...action.payload].sort((a, b) => sortByProp(a, b, 'libelle'));
                state.programmesFetchStatus = 'success';
            } else {
                console.error("fetchProgrammes payload is not an array:", action.payload);
                state.programmes = [];
                state.programmesFetchStatus = 'error';
            }
        }).addCase(fetchProgrammes.pending, (state, action) => {
            state.programmesFetchStatus = 'loading';

        }).addCase(fetchProgrammes.rejected, (state, action) => {

            state.programmesFetchStatus = 'error';

        });
    }


});
export const { addProgram } = programmeSlice.actions;
export default programmeSlice;